import { Tag } from "~/components/pages/settings/types";
import { AlertDto } from "~/redux/api/openapi.generated";

export type Attachment = {
  link: string;
  name: string;
  id: string;
  reference: string;
};
export type AttachmentInput = {
  files: FileList | null;
  removedFiles: Attachment[];
};
export enum Status {
  Open = "Open",
  InProgress = "In Progress",
  New = "New",
  Closed = "Closed",
  Rejected = "Rejected",
  Resolvable = "Pending Approval",
  Overdue = "Overdue",
  NonCompliant = "Non Compliant",
  Compliant = "Compliant",
  Voided = "Voided",
}

export type Role = {
  displayName: string;
  name: string;
  id: string;
};

type DirectReport = {
  id: string;
  name: string;
  isDisabled: boolean;
};

export type User = {
  id: string;
  firstName: string;
  lastName: string;
  employeeId: string | null;
  dateOfBirth: string; // ISO 8601 date string
  nationality: string | null;
  email: string;
  privateEmail: string | null;
  phoneNumber: string | null;
  title: string | null;
  sex: string | null;
  directReport: DirectReport;
  employmentType: string | null;
  hiredOn: string; // ISO 8601 date string
  avatar: string | null;
  isDisabled: boolean;
  role: Role;
  tags?: Tag[];
};

export interface Data {
  data: Array<AlertDto>;
}
